var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/email-large") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.7272727,5.5 C25.5297652,5.5 27,6.92258832 27,8.66666667 L27,21.3333333 C27,23.0774117 25.5297652,24.5 23.7272727,24.5 L6.27272727,24.5 C4.47023482,24.5 3,23.0774117 3,21.3333333 L3,8.66666667 C3,8.66061901 3.00001768,8.65457521 3.00005299,8.64853533 C3.00031951,8.63285705 3.00092837,8.61749549 3.00188515,8.60213851 C3.03630365,6.88772629 4.4924578,5.5 6.27272727,5.5 Z M24.818,10.693 L15.6255953,16.9203004 C15.2917091,17.1464464 14.8595911,17.1715738 14.5038756,16.9956824 L14.3744047,16.9203004 L5.181,10.693 L5.18181818,21.3333333 C5.18181818,21.8729343 5.61162575,22.3247863 6.15472919,22.382635 L6.27272727,22.3888889 L23.7272727,22.3888889 C24.3247803,22.3888889 24.8181818,21.9114772 24.8181818,21.3333333 L24.818,10.693 Z M23.7272727,7.61111111 L6.27272727,7.61111111 C5.84949276,7.61111111 5.47849199,7.85064579 5.2980792,8.19584461 L15,14.7667222 L24.7019208,8.19584461 C24.521508,7.85064579 24.1505072,7.61111111 23.7272727,7.61111111 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/email-large",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/black",
    mask: "url(#mask-2)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailLarge);
export default __webpack_public_path__ + "static/media/email-large.ba692a2fd0ccfcfef10b7b24129a3323.svg";
export { ForwardRef as ReactComponent };